import type { AxiosError } from "axios";

export type Callback<T, K> = (val: T) => K;
export type OutputCallback<T> = () => T;
export type TypedCallback<T> = (val: T) => void;
export type ObjectCallback = (val: any | null) => void;
export type ParamsCallback = (...params: any) => void;
export type EmptyCallback = () => void;
export type ChqApiError = AxiosError<{ message: string }>
export const ChqChangeEvent = 'chq-change'

declare global {
    interface Window {
        turnstile?: {
            render: (el: Element, opts: any) => string
            execute: (id?: string, options?: { callback?: EmptyCallback }) => void
            reset: (id?: string) => void
            remove: (id?: string) => void
        }, 
        XLSX: any
    }
}

export interface NameIdModel {
    id: number
    name: string
}

export interface SystemUser {
  userName: string;
  isAuthenticated: boolean;
  isSuperAdmin: boolean;
  canPrescribeDrugs: boolean;
  publicId: string;
  userId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  permissions: string[];
  clinicId: number;
  clinics: number[];
  clinic: Clinic;
  clinicCurrentDateTime: string;
}

export interface Clinic {
  clinicName: string;
  clinicAbbr: string;
  clinicPhone: string;
  clinicEmail: string;
  timeZone: string;
  twilioPhoneNumber: string;
  physicalAddressId: number;
  groupId: number;
  tenantId: string;
  publicId: string;
  enableMobileLocations: boolean;
  enableDecentralizedDrugLog: boolean;
  enableAmTasksDrugLog: boolean;
  enableExtendedExam: boolean;
  enableSpayNeuterTimeScheduling: boolean;
  enableWellnessScheduling: boolean;
  useKgInsteadOfPounds: boolean;
  defaultVetId: number | null;
  defaultMicrochipProviderId: number;
  weightMetric: string;
  subscriptionStatus: number;
  customerId: string;
  culture: string;
  isChatActive: boolean;
}

export interface AddressState {
  abbreviation: string
  country: string
  countryDescription: string
  name: string
}

export interface LookupService {
  countries(): Promise<NameIdModel[]>;
  states(): Promise<any[]>;
}
